import React from "react";
import { useSelector } from "types/store";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import CheckMarkImg from "images/Circle Check Light 2.svg";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import styles from "./style.module.css";
const InProgressStepsMessage = ({}) => {
    const agentSteps = useSelector((state) => chatGPTReducer.getAgentSteps(state));
    const currentAgentStep = useSelector((state) => chatGPTReducer.getCurrentAgentStep(state));
    const agentStepsType = useSelector((state) => chatGPTReducer.getAgentStepsType(state));
    return (React.createElement("div", { style: { display: "flex", flexDirection: "column" } }, agentSteps?.map((step) => {
        return React.createElement(InProgressAgentStep, { step: step, key: step?.id });
    })));
};
const InProgressAgentStep = ({ step }) => {
    const currentAgentStep = useSelector((state) => chatGPTReducer.getCurrentAgentStep(state));
    const agentSteps = useSelector((state) => chatGPTReducer.getAgentSteps(state));
    const currStepIndex = agentSteps?.findIndex((agentStep) => agentStep?.id === currentAgentStep?.id);
    const stepIndex = agentSteps?.findIndex((agentStep) => agentStep?.id === step?.id);
    const stepIsComplete = currStepIndex > stepIndex;
    const shouldShowStep = stepIndex <= currStepIndex;
    if (!shouldShowStep || step?.id === "USER_FEEDBACK") {
        return React.createElement(React.Fragment, null);
    }
    let retStepText = step?.label ?? "";
    if (step?.id === "DOUBLE_CHECK") {
        retStepText += ". " + step?.description;
    }
    return (React.createElement("div", { className: styles.inProgressAgentStepWrapper },
        React.createElement("div", { className: styles.inProgressAgentStepIcon }, stepIsComplete ? (React.createElement("img", { src: CheckMarkImg })) : (React.createElement(LoadingIndicator, { style: {
                width: "20px",
                height: "18px",
                scale: "0.35",
                margin: "-7px 24px 12px -8px"
            } }))),
        React.createElement("div", null, retStepText)));
};
export default InProgressStepsMessage;
